import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import className from 'classnames/bind'

import style from './CommonHeader.module.scss'

import IconPrev from '@Ui/images/myhouse/IconPrev'

const cx = className.bind(style)

type Props = {
  title?: any
  prevButton?: boolean
  textButton?: boolean
  buttonText?: string
  onClickTextButton?: (e: React.SyntheticEvent) => void
}

const CommonHeader: React.FC<Props> = ({ title, prevButton, textButton, buttonText, onClickTextButton }: Props) => {
  const history = useHistory()
  const [isScrollTop, setIsScrollTop] = useState(true)
  const scrollListener = () => {
    setIsScrollTop(window.scrollY <= 0)
  }

  const handleClickBack = (e: React.SyntheticEvent) => {
    e.preventDefault()
    history.goBack()
  }

  useEffect(() => {
    window.addEventListener('scroll', scrollListener)
    return () => {
      window.removeEventListener('scroll', scrollListener)
    }
  }, [])
  return (
    <header className={cx('article', !isScrollTop && 'border_line')}>
      <div className={cx('header')}>
        <div className={cx('inner')}>
          <h1 className={cx('title')}>{title}</h1>
          {prevButton && (
            <a href="#" className={cx('button', 'prev')} onClick={handleClickBack}>
              <IconPrev width="24" height="24" />
              <span className={cx('blind')}>이전 페이지</span>
            </a>
          )}
          {textButton && (
            <button type="button" className={cx('button', 'text')} onClick={onClickTextButton}>
              {buttonText}
            </button>
          )}
        </div>
      </div>
    </header>
  )
}

export default CommonHeader
